import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const clientIdAtom = atom("", "clientId").pipe(
  withLocalStorage("clientId"),
);
